import axios from "axios";
import { items, categories } from "InitialData/Items";
import { listData } from "InitialData/accounts/navBoxData";


class FileRequester {
  instance = null;

  constructor() {
    this.instance = axios.create({
      baseURL: "https://puffuapp.com/api",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      origin: "https://puffuapp.com/",
      withCredentials: false,
    });
  }

  setAuthTokenHeader(token) {
    this.instance = axios.create({
      baseURL: "https://puffuapp.com/api",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
      origin: "https://puffuapp.com/",
      withCredentials: false,
    });
  }

  // constructor() {
  //   axios.defaults.withCredentials = true;
  //   this.instance = axios.create({
  //     baseURL: "http://localhost:8080/api",
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //     },
  //     origin: "http://localhost:8080/",
  //     withCredentials: true,
  //   });
  // }

  // setAuthTokenHeader(token) {
  //   this.instance = axios.create({
  //     baseURL: "http://localhost:8080/api",
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       Authorization: token,
  //     },
  //     origin: "http://localhost:8080/",
  //     withCredentials: true,
  //   });
  // }

  async upload(data) {
    try {
      let promise = new Promise((resolve, reject) => {
        let result = "";
        this.instance
          .post("open/file/upload", data)
          .then((res) => {
            result = res.data;
          })
          .catch((ex) => {
            result = ex;
          })
          .finally(() => {
            resolve(result);
          });
      });
      let result = await promise;
      return result;
    } catch (e) {
      console.error("파일 업로드 오류:", e);
      return { error: e.message };
    }
  }

  // 비디오 업로드 전용 메소드 추가
  async uploadVideo(data, compress = true, onUploadProgress = null) {
    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'compress': compress.toString()
        }
      };

      // 업로드 진행 상태 콜백 추가
      if (onUploadProgress) {
        config.onUploadProgress = onUploadProgress;
      }

      let promise = new Promise((resolve, reject) => {
        let result = "";
        this.instance
          .post("open/videos/upload", data, config)
          .then((res) => {
            // ApiResponse 래핑 구조 처리
            result = res.data.data; // code, message, data 구조에서 data에 접근
          })
          .catch((ex) => {
            result = ex;
          })
          .finally(() => {
            resolve(result);
          });
      });
      let result = await promise;
      return result;
    } catch (e) {
      console.error("비디오 업로드 오류:", e);
      return { error: e.message };
    }
  }

  // 비디오 처리 상태 확인 메소드 추가
  async getVideoStatus(videoId) {
    try {
      const response = await this.instance.get(`open/videos/status/${videoId}`);
      // ApiResponse 래핑 구조 처리
      return response.data.data;
    } catch (e) {
      console.error("비디오 상태 확인 오류:", e);
      return { error: e.message, status: "error" };
    }
  }

  // 계약서 템플릿 업로드 메서드
  async uploadContractTemplate(data) {
    const token = localStorage.getItem('token');
    if (token) {
      this.setAuthTokenHeader(`Bearer ${token}`);
    }
    try {
      let promise = new Promise((resolve, reject) => {
        let result = "";
        this.instance
          .post("manager/contractTemplates/upload", data)
          .then((res) => {
            result = res.data;
          })
          .catch((ex) => {
            result = ex;
          })
          .finally(() => {
            resolve(result);
          });
      });
      let result = await promise;
      return result;
    } catch (e) {
      console.error("계약서 템플릿 업로드 오류:", e);
      return { error: e.message };
    }
  }

  // 서명된 계약서 PDF 업로드 메서드
  async uploadSignedContract(data) {
    const token = localStorage.getItem('token');
    if (token) {
      this.setAuthTokenHeader(`Bearer ${token}`);
    }
    try {
      let promise = new Promise((resolve, reject) => {
        let result = "";
        this.instance
          .post("manager/contracts/sign", data)
          .then((res) => {
            result = res.data;
          })
          .catch((ex) => {
            result = ex;
          })
          .finally(() => {
            resolve(result);
          });
      });
      let result = await promise;
      return result;
    } catch (e) {
      console.error("서명된 계약서 업로드 오류:", e);
      return { error: e.message };
    }
  }

  
    // 특정 계약서 템플릿 PDF 다운로드
    getContractTemplatePdf(templateId, callback) {
      const endpoint = `manager/contracts/templates/${templateId}/pdf`;
  
      // 토큰 직접 가져오기
      const token = localStorage.getItem('token');
  
      // 1. 직접 axios 인스턴스 대신 axios 메서드 호출
      axios({
        method: 'GET',
        url: `${process.env.REACT_APP_FILE_ACCESS_URL}${endpoint}`,
        responseType: 'arraybuffer', // 중요: 바이너리 데이터 처리를 위해
        headers: {
          // 조건부로 Authorization 헤더 추가
          ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
          'Accept': 'application/pdf'
        },
        withCredentials: false
      })
        .then(response => {
          console.log('PDF 응답 헤더:', response.headers);
          console.log('PDF 데이터 길이:', response.data ? response.data.byteLength : 'N/A');
  
          if (response.data && response.data instanceof ArrayBuffer) {
            callback(response.data, null);
          } else {
            console.error('응답 데이터가 ArrayBuffer가 아님:', typeof response.data);
            callback(null, new Error('응답 데이터 형식이 올바르지 않습니다.'));
          }
        })
        .catch(error => {
          console.error('PDF 템플릿 요청 오류:', error);
          callback(null, error);
        });
    }
  
  // 서명된 계약서 PDF 다운로드
  getSignedContractPdf(contractId, callback) {
    const endpoint = `manager/contracts/${contractId}/pdf`;
    
    // 토큰 직접 가져오기
    const token = localStorage.getItem('token');
    
    // 직접 axios 호출
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_FILE_ACCESS_URL}${endpoint}`,
      responseType: 'arraybuffer', // 중요: 바이너리 데이터 처리를 위해
      headers: {
        // 조건부로 Authorization 헤더 추가
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        'Accept': 'application/pdf'
      },
      withCredentials: false
    })
    .then(response => {
      console.log('PDF 응답 헤더:', response.headers);
      console.log('PDF 데이터 길이:', response.data ? response.data.byteLength : 'N/A');
      
      if (response.data && response.data instanceof ArrayBuffer) {
        callback(response.data, null);
      } else {
        console.error('응답 데이터가 ArrayBuffer가 아님:', typeof response.data);
        callback(null, new Error('응답 데이터 형식이 올바르지 않습니다.'));
      }
    })
    .catch(error => {
      console.error('서명된 계약서 PDF 요청 오류:', error);
      callback(null, error);
    });
  }
}



export default FileRequester;
